@if (rule4Expected || resulted) {
    <ul class="race-badges clearfix">
        @if (rule4Expected) {
            <li>
                <span class="race-badge r4">{{ sitecore.horseRacing.badges.R4 }}</span>
            </li>
        }
        @if (resulted) {
            <li>
                <span class="race-badge resulted">
                    <vn-icon name="sports-race-resulted" height="14" width="10" class="icon-race-resulted" />
                    {{ sitecore.horseRacing.badges.Resulted }}
                </span>
            </li>
        }
    </ul>
}
